// extracted by mini-css-extract-plugin
export default {"wrapper":"gallery_wrapper__-hEhD","title":"gallery_title__UWsxb"};